import { registerPlugin } from '@capacitor/core';
import { type ShopflowUserAgent as Type } from './definitions';

export const ShopflowUserAgent = registerPlugin<Type>('ShopflowUserAgent', {
  web: () => import('./web').then(m => new m.ShopflowUserAgentWeb()),
});